export default {
  dropdown: {
    backgroundColor: 'white',
    border: '1px solid rgb(204, 204, 204)',
    maxHeight: '20rem',
    minWidth: '160px',
    overflow: 'auto',
    position: 'absolute',
    right: '0.2rem',
    textAlign: 'left',
    zIndex: 666,
  },
  dropdownButton: {
    alignItems: 'center',
    backgroundColor: 'white',
    border: '1px solid rgb(204, 204, 204)',
    cursor: 'pointer',
    padding: '0.3rem 0.5rem',
    width: '10rem',
  },
  dropdownLink: {
    padding: '0.2rem 0.5rem',
    textDecoration: 'none',
    width: '100%',
  },
};
